import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Button from '@ux/button';
import ChatIcon from '@ux/icon/chat';
import { useContext } from '../RenderContext';
import Card from '../Card';
import { FeatureFlags, useFeatureFlag } from '../../hooks/switchboard';

const LP_BUNDLE_TARGET = '[id^="dc-messaging-button-container"] .dc-messaging-click-target';
const LP_OVERLAY_TARGET = '.LPMcontainer.LPMoverlay';
const LP_POLL_LIMIT = 60; // 30s at 500ms
export const LP_CHAT_PLID = 1592;

const getLpButton = (): HTMLElement | null =>
  document.querySelector<HTMLElement>(LP_BUNDLE_TARGET) ??
  document.querySelector<HTMLElement>(LP_OVERLAY_TARGET);

const ChatNow = () => {
  const intl = useIntl();
  const { settings: { privateLabelId } } = useContext();
  const isChatEnabled = useFeatureFlag(FeatureFlags.CONTACT_US_CHAT_NOW);
  const [isLpReady, setIsLpReady] = useState(false);

  useEffect(() => {
    if (isChatEnabled !== true || privateLabelId !== LP_CHAT_PLID) return;

    let polls = 0;
    const interval = setInterval(() => {
      polls += 1;
      if (getLpButton()) {
        setIsLpReady(true);
        clearInterval(interval);
      }
      else if (polls >= LP_POLL_LIMIT) {
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [isChatEnabled, privateLabelId]);

  if (isChatEnabled !== true || privateLabelId !== LP_CHAT_PLID) return null;

  const openChat = () => {
    getLpButton()?.click();
  };

  return (
    <Card className="contactUs-sidebar-chat">
      <h2 className="contactUs-sidebar-chat-title">
        <ChatIcon aria-hidden="true" className="contactUs-sidebar-chat-icon" width="0.85em" height="0.85em" />
        <FormattedMessage id="contactUs.chatNow.title" />
      </h2>
      <p><FormattedMessage id="contactUs.chatNow.description" /></p>
      <p className="contactUs-sidebar-chat-button">
        <Button
          design="primary"
          disabled={ !isLpReady }
          onClick={ openChat }
          data-eid="storefront.contact_us.chat_now.button.click"
          text={ intl.formatMessage({ id: 'contactUs.chatNow.button' }) }
        />
      </p>
      <p className="text-muted contactUs-sidebar-chat-hours"><FormattedMessage id="contactUs.chatNow.hours" /></p>
    </Card>
  );
};

export default ChatNow;
